import "./App.css";
import ReadRemoteFile from "./data";
function App() {
  return (
    <div className="App" style={{ background: "#424242" }}>
      <div>
        <ReadRemoteFile />
      </div>
    </div>
  );
}

export default App;
